import axios from 'axios';
import Cookies from 'js-cookie';
import { API_URL } from '../runtimeConfig';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const csrfToken = Cookies.get('csrftoken');
  if (csrfToken && ['post', 'put', 'patch', 'delete'].includes(config.method)) {
    config.headers['X-CSRFToken'] = csrfToken;
  }
  return config;
});

// Endpoints that legitimately return 401 to signal "not authenticated" and
// must not trigger the global redirect-to-login. The session/me boot calls
// own their own redirect logic in checkSessionSaga.
const NO_REDIRECT_ON_401 = [
  '/api/v1/auth/api/me/',
  '/api/v1/auth/api/session/',
];

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const skipRedirect = NO_REDIRECT_ON_401.some((p) => url.includes(p));
      const currentPath = window.location.pathname;
      if (!skipRedirect && currentPath !== '/login') {
        window.location.href = `/login?next=${encodeURIComponent(currentPath)}`;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
